import { Container, Stack } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNaverMap } from '../../../hooks/useMap';
import useResponsive from '../../../hooks/useResponsive';
import SearchAndListPanel from './SearchAndListPanel';
import { NaverMapPanel } from './NaverMapPanel';

const queryClient = new QueryClient();

export default function MapPageWithQueryClient() {
  return (
    <QueryClientProvider client={queryClient}>
      <MapPage />
    </QueryClientProvider>
  );
}

const styles = {
  paperContainer: {
    width: '100%',
  },
};

function MapPage() {
  const mdUp = useResponsive('up', 'md');
  const [search, setSearch] = useState('');
  const [categoryType, setCategoryType] = useState('');
  const [status, setStatus] = useState('');
  const [department, setDepartment] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const [boundForMap, setBoundForMap] = useState({});
  const [boundForList, setBoundForList] = useState({});

  const { setRef, map } = useNaverMap({
    onZoomChanged(e, map) {
      onBoundForMapChange(map);
    },
    onDragend(e, map) {
      onBoundForMapChange(map);
    },
  });

  function onBoundForMapChange(map) {
    const maxLat = _.result(map, 'getBounds._max._lat');
    const minLat = _.result(map, 'getBounds._min._lat');
    const maxLng = _.result(map, 'getBounds._max._lng');
    const minLng = _.result(map, 'getBounds._min._lng');
    setBoundForMap({
      maxLat,
      minLat,
      maxLng,
      minLng,
    });
  }

  function onBoundForListChange(map) {
    const maxLat = _.result(map, 'getBounds._max._lat');
    const minLat = _.result(map, 'getBounds._min._lat');
    const maxLng = _.result(map, 'getBounds._max._lng');
    const minLng = _.result(map, 'getBounds._min._lng');
    setBoundForList({
      maxLat,
      minLat,
      maxLng,
      minLng,
    });
  }

  useEffect(() => {
    if (map) {
      onBoundForListChange(map);
    }
  }, [map]);

  return (
    <>
      <Helmet>
        <title> 시설물 관리 서비스 </title>
      </Helmet>
      <Container maxWidth={false} disableGutters sx={{ height: '100%' }}>
        {mdUp ? (
          <Stack
            direction="row"
            width="100%"
            alignItems="stretch"
            height="100%"
          >
            <SearchAndListPanel
              search={search}
              setSearch={setSearch}
              type={categoryType}
              setType={setCategoryType}
              status={status}
              setStatus={setStatus}
              department={department}
              setDepartment={setDepartment}
              onFacilityIdChange={setSelectedId}
              bound={boundForList}
            />
            <NaverMapPanel
              map={map}
              setRef={setRef}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              search={search}
              inspectionStatus={status}
              department={department}
              categoryType={categoryType}
              bound={boundForMap}
              style={styles.paperContainer}
              position="relative"
              onListRefresh={() => onBoundForListChange(map)}
            />
          </Stack>
        ) : (
          <Stack width="100%" alignItems="stretch" height="100%">
            <NaverMapPanel
              map={map}
              setRef={setRef}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              search={search}
              inspectionStatus={status}
              department={department}
              categoryType={categoryType}
              bound={boundForMap}
              style={styles.paperContainer}
              position="relative"
              sx={{ minHeight: '375px' }}
              onListRefresh={() => onBoundForListChange(map)}
            />
            <SearchAndListPanel
              search={search}
              setSearch={setSearch}
              type={categoryType}
              setType={setCategoryType}
              status={status}
              setStatus={setStatus}
              department={department}
              setDepartment={setDepartment}
              onFacilityIdChange={setSelectedId}
              bound={boundForList}
            />
          </Stack>
        )}
      </Container>
    </>
  );
}
